import { AccountRaw } from "../domain/Account";

// MFA初期設定が必要か判別する
export const checkIsMfaSettingRequired = (account: AccountRaw | null) => {
  if (!account) return true;
  return account.use_mfa === null && account.identity_provider === "auth0";
};
